export default {
    /**
     * @description 存储在浏览器中的缓存过期时间
     * @type (mm) 毫秒
     */
    expireTime: 3600000,
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '运维管理后台',

    /**
     * 默认表单条数
     */
    defaultStrip: 12,

    specialStrip: 15,

    /**
     * 列表显示集
     */
    dropDown: [12, 14, 18, 30, 50, 100, 200, 300],

    /**
     * @description token在Cookie中存储的天数，默认1天
     */
    cookieExpires: '2h',
    /**
     * @description 是否使用国际化，默认为false
     *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
     *              用来在菜单中显示文字
     */
    useI18n: true,
    /**
     * @description api请求基础路径
     */
    baseUrl: {
        dev: 'http://127.0.0.1:8000/',
        pro: 'http://127.0.0.1:8000/'
    },
    /**
     * @description 默认打开的首页条件是在未加入团队或公司
     */
    perfect: 'perfect',
    /**
     * @description 默认打开的首页的路由name值，默认为home
     */
    homeName: 'main_index',
    /**
     * @description 需要加载的插件
     */
    plugin: {
        'error-store': {
            showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
            developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
        }
    },
    powerName: [
        { name: '用户', value: 7 },
        { name: '部门', value: 13 },
        { name: '职务', value: 10 }
    ],
    level: [
        { name: '无', value: 0, color: '#cccccc', icon: 'md-female' },
        { name: '低', value: 1, color: '#73cc33', icon: 'md-arrow-dropdown-circle' },
        { name: '中', value: 2, color: '#fc3', icon: 'md-remove-circle' },
        { name: '高', value: 3, color: '#ff9940', icon: 'md-arrow-dropup-circle' },
        { name: '紧急', value: 4, color: '#f24c3d', icon: 'ios-navigate' }
    ],
    status: [
        { name: '待评估', value: 1, color: '#ec8205', bg: 'rgb(255, 233, 207)' },
        { name: '进行中', value: 2, color: '#055fe6', bg: 'rgb(221, 235, 255)' },
        { name: '已完成', value: 3, color: '#198061', bg: 'rgb(195, 243, 203)' },
        { name: '已拒绝', value: 4, color: '#d60000', bg: '#fbd2c7' }
    ],
    assettype: [
        { name: '物理机', value: 1 },
        { name: '虚拟机', value: 2 },
        { name: '容器', value: 3 },
        { name: '网络设备', value: 4 },
        { name: '安全设备', value: 5 },
        { name: '云主机', value: 6 },
        { name: '其他', value: 7 }
    ],
    statusName: [
        { name: '运行中', value: 'Running', bg: '#19be6b' },
        { name: '启动中', value: 'Starting', bg: '#ef8f00' },
        { name: '停止中', value: 'Stopping', bg: '#c5c8ce' },
        { name: '已停止', value: 'Stopped', bg: '#ed4014' },
    ],
    dbInstanceType: [
        { name: '主实例', value: 'Primary' },
        { name: '只读实例', value: 'ReadOnly' },
        { name: '灾备实例', value: 'uard' },
        { name: '临时实例', value: 'Temp' }
    ],
    payInType: [
        { name: '按量付费', value: 'Postpaid' },
        { name: '包年包月', value: 'Prepaid' },
    ],
    dbInstanceStatus: [
        { name: '创建中', value: 'Creating', bg: '#c5c8ce' },
        { name: '使用中', value: 'Running', bg: '#19be6b' },
        { name: '删除中', value: 'Deleting', bg: '#ed4014' },
        { name: '重启中', value: 'Rebooting', bg: '#ed4014' },
        { name: '升降级中', value: 'DBInstanceClassChanging', bg: '#2d8cf0' },
        { name: '迁移中', value: 'TRANSING', bg: '#2d8cf0' },
        { name: '迁移版本中', value: 'EngineVersionUpgrading', bg: '#2d8cf0' },
        { name: '迁移数据到其他RDS中', value: 'TransingToOthers', bg: '#2d8cf0' },
        { name: '生产灾备实例中', value: 'GuardDBInstanceCreating', bg: '#2d8cf0' },
        { name: '备份恢复中', value: 'Restoring', bg: '#2d8cf0' },
        { name: '数据导入中', value: 'Importing', bg: '#2d8cf0' },
        { name: '从其他RDS实例导入数据中', value: 'ImportingFromOthers', bg: '#2d8cf0' },
        { name: '内外网切换中', value: 'DBInstanceNetTypeChanging', bg: '#2d8cf0' },
        { name: '容灾切换中', value: 'GuardSwitching', bg: '#2d8cf0' },
        { name: '实例克隆中', value: 'INS_CLONING', bg: '#2d8cf0' },
    ],
    manageSTATUS: [
        { name: '创建中', value: 'Creating', bg: '#c5c8ce' },
        { name: '使用中', value: 'Running', bg: '#19be6b' },
        { name: '删除中', value: 'Deleting', bg: '#ed4014' },
    ],
    SLBSTATUS: [
        { name: '已停止', value: 'inactive', bg: '#ff0000' },
        { name: '运行中', value: 'active', bg: '#009419' },
        { name: '已锁定', value: 'locked', bg: '#ccc' },
    ],
    PROJECTTYPE: [
        { name: '短期项目', value: 1 },
        { name: '长期项目', value: 2 },
        { name: '运维项目', value: 3 },
    ],
    PROJECTTIEM: [
        { name: '一星期', value: 5 },
        { name: '两星期', value: 10 },
        { name: '一个月', value: 23 },
        { name: '两个月', value: 45 },
        { name: '三个月', value: 67 },
        { name: '半年', value: 134 },
        { name: '一年', value: 261 },
    ],
    NOTIFYSTATUS: [
        { name: '分配', value: 'assign' },
        { name: '声明', value: 'claim' },
        { name: '清除截止时间', value: 'clearEndTime' },
        { name: '评论', value: 'comment' },
        { name: '内容', value: 'content' },
        { name: '创建', value: 'create' },
        { name: '创建子内容', value: 'createChild' },
        { name: '完成', value: 'done' },
        { name: '完成子内容', value: 'doneChild' },
        { name: '分配', value: 'edit' },
        { name: '邀请', value: 'inviteMember' },
        { name: '文件链接', value: 'linkFile' },
        { name: '名称', value: 'name' },
        { name: '前缀', value: 'pri' },
        { name: '恢复', value: 'recovery' },
        { name: '回收', value: 'recycle' },
        { name: '重做', value: 'redo' },
        { name: '重做子内容', value: 'redoChild' },
        { name: '删除执行器', value: 'removeExecutor' },
        { name: '删除会员', value: 'removeMember' },
        { name: '设置截止时间', value: 'setEndTime' },
        { name: '删除文件链接', value: 'unlinkFile' }
    ],
    SECTIONTYPELIST: [
        { value: 'document', text: "文本", icon: 'md-copy' },
        { value: 'mind', text: "脑图", icon: 'md-share' },
        { value: 'sheet', text: "表格", icon: 'md-apps' },
        { value: 'flow', text: "流程图", icon: 'md-git-merge' },
        { value: 'folder', text: "目录", icon: 'md-folder-open' }
    ],
}